/**
 * Web adapter for @react-native-voice/voice using Web SpeechRecognition API.
 */
class VoiceWeb {
    private recognition: any = null;

    onSpeechStart: ((e: any) => void) | null = null;
    onSpeechEnd: ((e: any) => void) | null = null;
    onSpeechResults: ((e: any) => void) | null = null;
    onSpeechError: ((e: any) => void) | null = null;

    constructor() {
        if (typeof window !== 'undefined') {
            const SpeechRecognition =
                (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

            if (SpeechRecognition) {
                this.recognition = new SpeechRecognition();
                this.recognition.continuous = false;
                this.recognition.interimResults = false;

                this.recognition.onstart = () => {
                    this.onSpeechStart?.({ error: false });
                };

                this.recognition.onend = () => {
                    this.onSpeechEnd?.({ error: false });
                };

                this.recognition.onresult = (event: any) => {
                    const results: string[] = [];
                    for (let i = 0; i < event.results.length; i++) {
                        results.push(event.results[i][0].transcript);
                    }
                    this.onSpeechResults?.({ value: results });
                };

                this.recognition.onerror = (event: any) => {
                    this.onSpeechError?.({ error: { message: event.error || 'Speech recognition error' } });
                };
            }
        }
    }

    async start(locale: string = 'en-US'): Promise<void> {
        if (!this.recognition) {
            const err = new Error('Speech Recognition API not supported in this browser');
            this.onSpeechError?.({ error: { message: err.message } });
            throw err;
        }

        try {
            this.recognition.lang = locale;
            this.recognition.start();
        } catch (e: any) {
            console.warn('[VoiceWeb] Start error:', e);
            this.onSpeechError?.({ error: { message: e?.message || 'Failed to start voice recognition' } });
        }
    }

    async stop(): Promise<void> {
        if (this.recognition) {
            try {
                this.recognition.stop();
            } catch (e) {
                console.warn('[VoiceWeb] Stop error:', e);
            }
        }
    }

    async destroy(): Promise<void> {
        if (this.recognition) {
            try {
                this.recognition.abort();
            } catch (e) {
                console.warn('[VoiceWeb] Abort error:', e);
            }
        }
    }
}

export default new VoiceWeb();
